var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ck-form",class:{ 'ck-form-right': _vm.labelPosition === 'right',
                'ck-form-top': _vm.labelPosition === 'top',
                'ck-form-left': _vm.labelPosition === 'left'}},[_c('form',[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ba85843","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ck-form/ck-form.vue
// module id = 598
// module chunks = 0